import { agreementMap } from './agreementMap'
import AgreementText from './AgreementText'
import React from 'react'
import { Checkbox } from 'antd'
export function UserAgreement() {
  return <AgreementText {...agreementMap.get('userAgreement')} />
}

export function PrivateAgreement() {
  return <AgreementText {...agreementMap.get('privateAgreement')} />
}

export function ThirdPartyAgreement() {
  return <AgreementText {...agreementMap.get('thirdPartyAgreement')} />
}

export function PersonalInfoAgreement() {
  return <AgreementText {...agreementMap.get('personalInfoAgreement')} />
}

export function EsignAgreement() {
  return <AgreementText {...agreementMap.get('esignAgreement')} />
}

export default function Agreement({
  agree,
  setAgree,
}: {
  agree: boolean
  setAgree: React.Dispatch<React.SetStateAction<boolean>>
}) {
  return (
    <Checkbox
      style={{
        marginBottom: 20,
      }}
      onChange={(checked) => {
        setAgree(checked.target.checked)
      }}
      checked={agree}
    >
      我已阅读并同意
      <UserAgreement />和
      <PrivateAgreement />、
      <ThirdPartyAgreement />
    </Checkbox>
  )
}
